import React from "react";
import Pill from "components/Pill";
import { PRICING_TABLE_PRODUCT_LIMIT_MAX } from "components/FormerEditor/common/constants";

const LimitNotice = () => (
  <div className="ph3">
    <Pill
      customClasses={{
        container: "flex items-end justify-start",
        copy: "f7 ph2 pv1 br2 fw5 flex-shrink-0"
      }}
      copy={`Pricing table product limit reached (max ${PRICING_TABLE_PRODUCT_LIMIT_MAX})`}
    />
  </div>
);

export default LimitNotice;
